<template>
	<b-modal :visible="visible" @hide="hide" :title="title" size="xl" modal-class="document-viewer" hide-footer>
		<iframe :src='src' class="document-viewer-frame"></iframe>
	</b-modal>
</template>

<script>
	import appSettings from "../../../appconfig.json"

	export default {
		name: 'DocumentViewer',
		props: {
			visible: null,
			title: null,
			filePath: null
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			src: function () {
				return `${appSettings.mopaneApi.documentViewerUrl}?referrer=${this.profile.bucket}&filename=${this.filePath}`
			}
		},
		methods: {
			hide: function () {
				this.$emit("hide")
			}
		}
	}
</script>

<style>
	.document-viewer .modal-dialog {
		max-width: 100% !important;
		margin-top: 5vh !important;
		margin-left: 2vw !important;
		margin-bottom: 5vh !important;
		margin-right: 2vw !important;
		top: 0 !important;
		bottom: 0 !important;
		left: 0 !important;
		right: 0 !important;
		height: 90vh !important;
		display: flex !important;
	}

	.document-viewer .modal-content {
		border-radius: 16px;
		overflow:hidden;
	}

	.document-viewer .modal-header {
		margin: 0 -1px;
		padding: 10px 20px;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		background-color: #081e4a;
	}

		.document-viewer .modal-header .modal-title {
			color: #ffffff !important;
		}

		.document-viewer .modal-header .close {
			color: #ffffff !important;
			opacity: 1;
			font-weight: 100;
		}

	.document-viewer .modal-body {
		padding: 0;
	}
</style>
<style scoped>
	.document-viewer-frame {
		width: 100%;
		height: 100%;
		border: none;
	}
</style>